const middleware = {}

middleware['admin/auth'] = require('../middleware/admin/auth.js')
middleware['admin/auth'] = middleware['admin/auth'].default || middleware['admin/auth']

middleware['admin/notAuth'] = require('../middleware/admin/notAuth.js')
middleware['admin/notAuth'] = middleware['admin/notAuth'].default || middleware['admin/notAuth']

middleware['frontend/accept_document'] = require('../middleware/frontend/accept_document.js')
middleware['frontend/accept_document'] = middleware['frontend/accept_document'].default || middleware['frontend/accept_document']

middleware['frontend/accept_from_ls'] = require('../middleware/frontend/accept_from_ls.js')
middleware['frontend/accept_from_ls'] = middleware['frontend/accept_from_ls'].default || middleware['frontend/accept_from_ls']

middleware['frontend/add_to_manual'] = require('../middleware/frontend/add_to_manual.js')
middleware['frontend/add_to_manual'] = middleware['frontend/add_to_manual'].default || middleware['frontend/add_to_manual']

middleware['frontend/application'] = require('../middleware/frontend/application.js')
middleware['frontend/application'] = middleware['frontend/application'].default || middleware['frontend/application']

middleware['frontend/auth'] = require('../middleware/frontend/auth.js')
middleware['frontend/auth'] = middleware['frontend/auth'].default || middleware['frontend/auth']

middleware['frontend/basicAuth'] = require('../middleware/frontend/basicAuth.js')
middleware['frontend/basicAuth'] = middleware['frontend/basicAuth'].default || middleware['frontend/basicAuth']

middleware['frontend/breadcrumbs'] = require('../middleware/frontend/breadcrumbs.js')
middleware['frontend/breadcrumbs'] = middleware['frontend/breadcrumbs'].default || middleware['frontend/breadcrumbs']

middleware['frontend/company_default_type'] = require('../middleware/frontend/company_default_type.js')
middleware['frontend/company_default_type'] = middleware['frontend/company_default_type'].default || middleware['frontend/company_default_type']

middleware['frontend/dashboard'] = require('../middleware/frontend/dashboard.js')
middleware['frontend/dashboard'] = middleware['frontend/dashboard'].default || middleware['frontend/dashboard']

middleware['frontend/document'] = require('../middleware/frontend/document.js')
middleware['frontend/document'] = middleware['frontend/document'].default || middleware['frontend/document']

middleware['frontend/is_role_application'] = require('../middleware/frontend/is_role_application.js')
middleware['frontend/is_role_application'] = middleware['frontend/is_role_application'].default || middleware['frontend/is_role_application']

middleware['frontend/isRoot'] = require('../middleware/frontend/isRoot.js')
middleware['frontend/isRoot'] = middleware['frontend/isRoot'].default || middleware['frontend/isRoot']

middleware['frontend/leading'] = require('../middleware/frontend/leading.js')
middleware['frontend/leading'] = middleware['frontend/leading'].default || middleware['frontend/leading']

middleware['frontend/notAuth'] = require('../middleware/frontend/notAuth.js')
middleware['frontend/notAuth'] = middleware['frontend/notAuth'].default || middleware['frontend/notAuth']

middleware['frontend/plan_assign_todo'] = require('../middleware/frontend/plan_assign_todo.js')
middleware['frontend/plan_assign_todo'] = middleware['frontend/plan_assign_todo'].default || middleware['frontend/plan_assign_todo']

middleware['frontend/plan_crud_manual'] = require('../middleware/frontend/plan_crud_manual.js')
middleware['frontend/plan_crud_manual'] = middleware['frontend/plan_crud_manual'].default || middleware['frontend/plan_crud_manual']

middleware['frontend/plan_crud_todo'] = require('../middleware/frontend/plan_crud_todo.js')
middleware['frontend/plan_crud_todo'] = middleware['frontend/plan_crud_todo'].default || middleware['frontend/plan_crud_todo']

middleware['frontend/plan_download_document_template'] = require('../middleware/frontend/plan_download_document_template.js')
middleware['frontend/plan_download_document_template'] = middleware['frontend/plan_download_document_template'].default || middleware['frontend/plan_download_document_template']

middleware['frontend/plan_group_chat'] = require('../middleware/frontend/plan_group_chat.js')
middleware['frontend/plan_group_chat'] = middleware['frontend/plan_group_chat'].default || middleware['frontend/plan_group_chat']

middleware['frontend/plan_manager_group_user'] = require('../middleware/frontend/plan_manager_group_user.js')
middleware['frontend/plan_manager_group_user'] = middleware['frontend/plan_manager_group_user'].default || middleware['frontend/plan_manager_group_user']

middleware['frontend/plan_manual_add_to_todo'] = require('../middleware/frontend/plan_manual_add_to_todo.js')
middleware['frontend/plan_manual_add_to_todo'] = middleware['frontend/plan_manual_add_to_todo'].default || middleware['frontend/plan_manual_add_to_todo']

middleware['frontend/plan_proposal'] = require('../middleware/frontend/plan_proposal.js')
middleware['frontend/plan_proposal'] = middleware['frontend/plan_proposal'].default || middleware['frontend/plan_proposal']

middleware['frontend/plan_todo_add_to_manual'] = require('../middleware/frontend/plan_todo_add_to_manual.js')
middleware['frontend/plan_todo_add_to_manual'] = middleware['frontend/plan_todo_add_to_manual'].default || middleware['frontend/plan_todo_add_to_manual']

middleware['frontend/plan_view_works'] = require('../middleware/frontend/plan_view_works.js')
middleware['frontend/plan_view_works'] = middleware['frontend/plan_view_works'].default || middleware['frontend/plan_view_works']

middleware['frontend/plan_work_add_to_manual'] = require('../middleware/frontend/plan_work_add_to_manual.js')
middleware['frontend/plan_work_add_to_manual'] = middleware['frontend/plan_work_add_to_manual'].default || middleware['frontend/plan_work_add_to_manual']

middleware['frontend/plan_work_add_to_todo'] = require('../middleware/frontend/plan_work_add_to_todo.js')
middleware['frontend/plan_work_add_to_todo'] = middleware['frontend/plan_work_add_to_todo'].default || middleware['frontend/plan_work_add_to_todo']

middleware['frontend/settings'] = require('../middleware/frontend/settings.js')
middleware['frontend/settings'] = middleware['frontend/settings'].default || middleware['frontend/settings']

middleware['frontend/workflow'] = require('../middleware/frontend/workflow.js')
middleware['frontend/workflow'] = middleware['frontend/workflow'].default || middleware['frontend/workflow']

export default middleware
